import { createSlice } from "@reduxjs/toolkit";
import { fetchTickets, createTicket, updateTickets, deleteTicket } from "./ticketsThunks";


const ticketsSlice = createSlice({
    name: "tickets",
    initialState: {
        tickets: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {    // disaridan gelen actionlari yakalamak icin
        
        ////////////////////
        // Fetch tickets //
        ////////////////////
        builder.addCase(fetchTickets.pending, (state) => { // eger fetchTickets cagirilirsa pending durumunda o zaman state loading true olur ve error null olur
            state.loading = true;
            state.error = null;
        });

        builder.addCase(fetchTickets.fulfilled, (state, action) => { 
            state.loading = false;
            state.tickets = action.payload;
        });

        builder.addCase(fetchTickets.rejected, (state, action) => { 
            state.loading = false;
            state.error = action.error.message;
        }); 

        //////////////////////
        // Create ticket //
        //////////////////////
        builder.addCase(createTicket.pending, (state) => {
            state.loading = true;
            state.error = null;
        }); 
        builder.addCase(createTicket.fulfilled, (state, action) => {
            state.loading = false;
            state.tickets.push(action.payload); // yeni ticket i arraya ekler
        });
        builder.addCase(createTicket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        ///////////////////////
        // Update tickets //
        ///////////////////////
        builder.addCase(updateTickets.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateTickets.fulfilled, (state, action) => {
            state.loading = false;
            const index = state.tickets.findIndex(ticket => ticket.id === action.payload.id);
            if (index !== -1) {
                state.tickets[index] = action.payload; // guncellenen ticket i tickets arrayinde bulur ve gunceller
            }   
        });
        builder.addCase(updateTickets.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });


         ///////////////////////
        // Delete tickets //
        ///////////////////////
        builder.addCase(deleteTicket.pending, (state) => {
            state.loading = true;
            state.error = null;
        }); 
        builder.addCase(deleteTicket.fulfilled, (state, action) => {
            state.loading = false;
            state.tickets = state.tickets.filter(ticket => ticket.id !== action.payload); // silinen ticket i tickets arrayinden cikarir
        });
        builder.addCase(deleteTicket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default ticketsSlice.reducer;